// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"28cb0dcd","887":"1956f788"}[chunkId] + ".chunk.js";
};